import {FINDER_OVERVIEW_SET_ADVANCED_SEARCH_OPTIONS} from '~/frontend/src/constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {String} dataContext
 * @param {Schema} schema
 * @param {String} status
 * @param {String} timezone
 * @param {String} timestamp
 *
 * @return {void}
 */
const setAdvancedSearchOptions = ( panelKey : string, dataContext : string, schema : Schema, status : Status, timezone : string, timestamp : string ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: FINDER_OVERVIEW_SET_ADVANCED_SEARCH_OPTIONS,
        panelKey,
        dataContext,
        status,
        timezone,
        timestamp
    } );

    // clear global data
    global.data[ dataContext ] = {
        items     : {},
        references: {},
        schema
    };

    dispatch( clearElusiveData( panelKey ) );
}
export type SetAdvancedSearchOptions = typeof setAdvancedSearchOptions;

export default setAdvancedSearchOptions;
